app.controller("AddProgramController", [
    "$scope", "StaticData", "ProgramService", "$uibModalInstance", "InfoModal",
    function ($scope, StaticData, ProgramService, $uibModalInstance, InfoModal) {
        $scope.faculties = [];
        $scope.levels = [];
        $scope.name = "";
        $scope.code = "";
        $scope.faculty = "";
        $scope.speciality = "";
        $scope.level = "";
        $scope.credits = 240;
        $scope.semesters = 8;

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = faculties;
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = levels;
        });

        $scope.changeLevel = function () {
            $scope.credits = $scope.level.credits;
            $scope.semesters = $scope.level.semesters;
        };

        $scope.create = function () {

            if (!$scope.addProgramForm.$valid) {
                InfoModal.show({message: "შეავსეთ ყველა ველი სწორად", title: "შეცდომა"});
                return;
            }

            ProgramService.create({
                code: $scope.code,
                name: $scope.name,
                speciality: $scope.speciality,
                faculty: $scope.faculty,
                semesters: $scope.semesters,
                level: $scope.level._id,
                credits: $scope.credits
            }).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);